exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (max-width: 768px){\n.VueCarousel-dot-container[data-v-460d2372]{ display:none!important\n}\n}\n", ""]);

// exports
